(() => {
  const modalId = 'search-modal';

  const waitForDialogComponent = async (timeout = 1400) => {
    if (!window.customElements) return false;
    if (customElements.get('dialog-component')) return true;

    return Promise.race([
      customElements.whenDefined('dialog-component').then(() => true),
      new Promise((resolve) => window.setTimeout(() => resolve(false), timeout))
    ]);
  };

  const configureSearchModal = () => {
    const modal = document.getElementById(modalId);
    const triggers = Array.from(document.querySelectorAll('.cz-search-link'));

    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-controls', modalId);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
    });

    if (!modal) return;

    const form = modal.querySelector('form[role="search"]');
    const input = modal.querySelector('input[name="q"]');
    const viewAllButton = modal.querySelector('[ref="viewAllButton"]');

    if (form && !form.querySelector('input[name="type"]')) {
      const typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';
      form.appendChild(typeInput);
    }

    if (input) {
      input.placeholder = 'Buscar productos, marcas o necesidades';
      input.setAttribute('enterkeyhint', 'search');
    }

    if (viewAllButton) viewAllButton.textContent = 'Ver todos los resultados';

    modal.addEventListener('dialog:open', () => {
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      window.requestAnimationFrame(() => input?.focus());
    });

    modal.addEventListener('dialog:close', () => {
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    });
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.cz-search-link');
    if (!trigger) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const modal = document.getElementById(modalId);
    if (!modal) return;

    event.preventDefault();
    const ready = await waitForDialogComponent();

    if (!ready || typeof modal.showDialog !== 'function') {
      window.location.assign(trigger.href);
      return;
    }

    modal.showDialog();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', configureSearchModal, { once: true });
  } else {
    configureSearchModal();
  }
})();
